import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRichText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M9.213 6.48v.732a1.11 1.11 0 0 1-1.107 1.113A1.11 1.11 0 0 1 7 7.212V5.665c0-.779.627-1.41 1.401-1.41h17.11c.775 0 1.402.631 1.402 1.41v1.547a1.11 1.11 0 0 1-1.106 1.113A1.11 1.11 0 0 1 24.7 7.212v-.731h-6.638v15.293h1.223c.61 0 1.106.498 1.106 1.113A1.11 1.11 0 0 1 19.286 24h-4.659a1.11 1.11 0 0 1-1.106-1.113 1.11 1.11 0 0 1 1.106-1.113h1.223V6.481z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRichText;
